import React from "react";
import { useNavigate } from "react-router-dom";
import { 
    Box,
    Typography,
    Button,
    Paper,
    Alert
} from "@mui/material";
import { HourglassEmpty } from "@mui/icons-material";

export default function KYCWaitingApproval() {
    const navigate = useNavigate();

    return (
        <Box sx={{ maxWidth: 600, mx: "auto", p: 3 }}>
            <Paper sx={{ p: 4, textAlign: "center" }}>
                <HourglassEmpty sx={{ fontSize: 80, color: "warning.main", mb: 2 }} />
        
                <Typography variant="h4" gutterBottom>
          KYC en Revisión
                </Typography>
        
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Tu solicitud de verificación KYC está siendo revisada por nuestro equipo. 
          Este proceso puede tomar entre 24-48 horas.
                </Typography>

                <Alert severity="info" sx={{ mb: 3 }}>
          Te notificaremos por email cuando tu verificación sea aprobada o si necesitamos información adicional.
                </Alert>

                <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={() => navigate("/dashboard")}
                    >
            Ir al Dashboard
                    </Button>
          
                    <Button
                        variant="contained"
                        onClick={() => navigate("/opportunities")}
                    >
            Ver Oportunidades
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
} 